import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table,
	Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery';
import moment from 'moment';
import AcademicPage from '../../views/AcademicPage/';

class Exam extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			acyear: '',
			cls: '',
			examname: '',
			_message: '',
			alertClass: '',
			_redirect: false,
			posts: [],
			accyear: [],
			exams: [],
			subj: [],
			modal: false,
			modal1: false,
			modal2: false,
			modal3: false,
			timetab: [],
			data: [],
			subject: '',
			exdate: '',
			stime: '',
			etime: '',
			maxmark: '',
			passmark: '',
		}
		this.onChange = this.onChange.bind(this);
		this.onExChange = this.onExChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onUpdate1 = this.onUpdate1.bind(this);
		this.onUpdate2 = this.onUpdate2.bind(this);
		this.onUpdate3 = this.onUpdate3.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.toggle = this.toggle.bind(this);
		this.toggle1 = this.toggle1.bind(this);
		this.toggle2 = this.toggle2.bind(this);
		this.toggle3 = this.toggle3.bind(this);
		this.onAcChange = this.onAcChange.bind(this);
	}
	
	onAcChange(e) {
		this.setState({ [e.target.name]: e.target.value });
		this.getexam();
	}

	toggle1() {
		this.setState({
			modal1: !this.state.modal1
		});
	}
	toggle2() {
		this.setState({
			modal2: !this.state.modal2
		});
	}
	toggle3() {
		this.setState({
			modal3: !this.state.modal3
		});
	}
	toggle() {
		this.setState({
			modal: !this.state.modal
		});
	}

	handleExdateChange(id, e) {

		this.setState({
			modal1: !this.state.modal1
		});
		this.state.subject = id;
		this.state.exdate = e.target.value;
	}

	handleTimeChange(id, e) {

		this.setState({
			modal2: !this.state.modal2
		});
		this.state.subject = id;
		this.state.stime = e.target.value;
		this.state.etime = e.target.id;
	}

	handleMaxChange(id, e) {

		this.setState({
			modal3: !this.state.modal3
		});
		this.state.subject = id;
		this.state.maxmark = e.target.value;
	}

	handlePassChange(id, e) {

		this.setState({
			modal: !this.state.modal
		});
		this.state.subject = id;
		this.state.passmark = e.target.value;
	}

	onhandleChange(id, e) {

		var index = this.state.timetab.findIndex(function (obj) {
			return (obj.subject == id);
		});

		if (index === -1) {
			this.state.timetab.push({ "subject": id, "exdate": e.target.value, "ftime": 0, "ttime": 0, "maxmark": 0, "passmark": 0 });
		}
		else {

			this.state.timetab[index].exdate = e.target.value;

		}
		console.log(this.state.timetab);
	}

	onftimeChange(id, e) {

		var index = this.state.timetab.findIndex(function (obj) {
			return (obj.subject == id);
		});

		if (index != -1) {

			this.state.timetab[index].ftime = e.target.value;

		}
		console.log(this.state.timetab);
	}

	onttimeChange(id, e) {

		var index = this.state.timetab.findIndex(function (obj) {
			return (obj.subject == id);
		});

		if (index != -1) {

			this.state.timetab[index].ttime = e.target.value;

		}
		console.log(this.state.timetab);
	}

	onMaxmarkChange(id, e) {

		var index = this.state.timetab.findIndex(function (obj) {
			return (obj.subject == id);
		});

		if (index != -1) {

			this.state.timetab[index].maxmark = e.target.value;

		}
		console.log(this.state.timetab);
	}

	onPassmarkChange(id, e) {

		var index = this.state.timetab.findIndex(function (obj) {
			return (obj.subject == id);
		});

		if (index != -1) {

			this.state.timetab[index].passmark = e.target.value;

		}
		console.log(this.state.timetab);
	}

	/** set value **/
	onChange(e) {
		this.setState({ [e.target.name]: e.target.value });
		//this.getexam();
		//his.getsubject();
		//this.getdata();
	}

	onExChange(e) {

		this.setState({ [e.target.name]: e.target.value });
		this.getsubject();
		this.getdata();

	}

	handleDateChange(id, e) {

		this.setState({
			modal: !this.state.modal
		});
		this.state.subid = id;
		console.log(this.state);
	}

	onClick(e) {

		document.getElementById("examform").reset();
	}

	onSubmit(e) {
		e.preventDefault();
		$("#showLoader").show();
		PostData('exam/savetimetable', this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson.status == '1') {
				this.setState({
					_message: 'Exam Time Table Created Successfully!..',
					alertClass: 'alert alert-success',
				});
				this.setState({ timetab: '' });
				this.getacyear();
				this.getclass();
				this.getdata();
			}
			else {

				this.setState({
					_message: 'Invalid Key',
					alertClass: 'alert alert-danger'
				});
			}
		});
	}

	onUpdate1() {
		$("#showLoader").show();
		PostData('exam/editexamdate', this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson.status == '1') {
				this.toggle1();
				this.setState({
					_message: 'Time Table Updated Successfully!..',
					alertClass: 'alert alert-success',
				});
				this.setState({ subject: '', passmark: '' });
				this.getacyear();
				this.getclass();
				this.getdata();
			}
			else {
				this.toggle1();
				this.setState({
					_message: 'Invalid Key',
					alertClass: 'alert alert-danger'
				});
			}
		});

	}

	onUpdate2() {
		$("#showLoader").show();
		PostData('exam/editexamtime', this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson.status == '1') {
				this.toggle2();
				this.setState({
					_message: 'Time Table Updated Successfully!..',
					alertClass: 'alert alert-success',
				});
				this.setState({ subject: '', passmark: '' });
				this.getacyear();
				this.getclass();
				this.getdata();
			}
			else {
				this.toggle2();
				this.setState({
					_message: 'Invalid Key',
					alertClass: 'alert alert-danger'
				});
			}
		});

	}

	onUpdate3() {
		$("#showLoader").show();
		PostData('exam/editmaxmark', this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson.status == '1') {
				this.toggle3();
				this.setState({
					_message: 'Time Table Updated Successfully!..',
					alertClass: 'alert alert-success',
				});
				this.setState({ subject: '', passmark: '' });
				this.getacyear();
				this.getclass();
				this.getdata();
			}
			else {
				this.toggle3();
				this.setState({
					_message: 'Invalid Key',
					alertClass: 'alert alert-danger'
				});
			}
		});

	}

	onUpdate() {
		$("#showLoader").show();
		PostData('exam/editpassmark', this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson.status == '1') {
				this.toggle();
				this.setState({
					_message: 'Time Table Updated Successfully!..',
					alertClass: 'alert alert-success',
				});
				this.setState({ subject: '', passmark: '' });
				this.getacyear();
				this.getclass();
				this.getdata();
			}
			else {
				this.toggle();
				this.setState({
					_message: 'Invalid Key',
					alertClass: 'alert alert-danger'
				});
			}
		});

	}

	componentWillMount() {

		this.getacyear();
		this.getclass();
	}

	/** get Academic Year **/
	getacyear() {
		$("#showLoader").show();
		GetData('academic/getacyear').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					accyear: responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
				this.getexam();
				this.getsubject();
				//this.getdata();
			}
		});
	}

	getclass() {
		$("#showLoader").show();
		GetData('classs/getclass').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson
				});

				this.getsubject();
				//this.getdata();
			}
		});
	}

	getexam() {

		var ac = $("#year").val();
		GetData('exam/getexambyacyear/' + ac).then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					exams: responseJson
				});

				//this.getdata();
			}
		});
	}

	getsubject() {

		var ac = $("#year").val();
		var cls = $("#clas").val();
		GetData('assignsubject/getsubbyclsdim/' + ac + '/' + cls).then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					subj: responseJson
				});
			}
		});
	}

	getdata() {

		var ac = $("#year").val();
		var cls = $("#clas").val();
		var exam = $("#exam").val();
		$("#showLoader").show();
		GetData('exam/gettimetable/' + ac + '/' + cls + '/' + exam).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					data: responseJson
				});
			}
		});
	}

	getexamdate(subid) {

		var dat = [];

		if (this.checkexdate(subid) != false) {

			dat.push(<td><Button size="sm" color="primary" value={this.checkexdate(subid)} onClick={this.handleExdateChange.bind(this, subid)}>{this.checkexdate(subid)}</Button></td>);
		}
		else {

			dat.push(<td><input type="date" name="exdate" onChange={this.onhandleChange.bind(this, subid)} /></td>);
		}

		return dat;
	}

	checkexdate(subid) {

		var bstate = false;

		for (var i = 0; i < this.state.data.length; i++) {

			if (this.state.data[i].subject == subid) {

				bstate = this.state.data[i].examdate;
				break;
			}
			else {

				bstate = false;
			}
		}

		return bstate;
	}

	getexamtime(subid) {

		var extime = [];

		if (this.checkftime(subid) != false && this.checkttime(subid) != false) {

			extime.push(<td><Button size="sm" color="primary" value={this.checkftime(subid)} id={this.checkttime(subid)} onClick={this.handleTimeChange.bind(this, subid)}>{this.checkftime(subid)} - {this.checkttime(subid)}</Button></td>);
		}
		else {

			extime.push(<td><input type="time" name="ftime" onChange={this.onftimeChange.bind(this, subid)} />
				<input type="time" name="ttime" onChange={this.onttimeChange.bind(this, subid)} /></td>);
		}

		return extime;
	}

	checkftime(subid) {

		var bstate = false;

		for (var i = 0; i < this.state.data.length; i++) {

			if (this.state.data[i].subject == subid) {

				bstate = this.state.data[i].starttime;
				break;
			}
			else {

				bstate = false;
			}
		}

		return bstate;

	}

	checkttime(subid) {

		var bstate = false;

		for (var i = 0; i < this.state.data.length; i++) {

			if (this.state.data[i].subject == subid) {

				bstate = this.state.data[i].endtime;
				break;
			}
			else {

				bstate = false;
			}
		}

		return bstate;

	}

	getmaxmark(subid) {

		var max = [];

		if (this.checkmaxmark(subid) != false) {

			max.push(<td><Button size="sm" color="primary" value={this.checkmaxmark(subid)} onClick={this.handleMaxChange.bind(this, subid)}>{this.checkmaxmark(subid)}</Button></td>);
		}
		else {

			max.push(<td><input type="text" name="maxmark" onChange={this.onMaxmarkChange.bind(this, subid)} /></td>);
		}

		return max;
	}

	checkmaxmark(subid) {

		var bstate = false;

		for (var i = 0; i < this.state.data.length; i++) {

			if (this.state.data[i].subject == subid) {

				if (this.state.data[i].maxmark == 0) {

					bstate = 'N/A';
					break;
				}
				else {

					bstate = this.state.data[i].maxmark;
					break;
				}
			}
			else {

				bstate = false;
			}
		}

		return bstate;
		console.log(bstate);
	}

	getpassmark(subid) {

		var pass = [];

		if (this.checkpassmark(subid) != false) {

			pass.push(<td><Button size="sm" color="primary" value={this.checkpassmark(subid)} onClick={this.handlePassChange.bind(this, subid)}>{this.checkpassmark(subid)}</Button></td>);
		}
		else {

			pass.push(<td><input type="text" name="passmark" onChange={this.onPassmarkChange.bind(this, subid)} /></td>);
		}

		return pass;
	}



	checkpassmark(subid) {

		var bstate = false;

		for (var i = 0; i < this.state.data.length; i++) {

			if (this.state.data[i].subject == subid) {

				if (this.state.data[i].passmark == 0) {

					bstate = 'N/A';
					break;
				}
				else {

					bstate = this.state.data[i].passmark;
					break;
				}
			}
			else {

				bstate = false;
			}
		}

		return bstate;
	}

	checktime(time) {

		var dt = moment(time, ["h:mm a"]).format("HH:mm");
		return dt;
	}

	render() {

		if (this.state._redirect) {

			return (<Redirect to={'/subject/subjectupdate/' + this.state.idd} />);

		}

		var exa = this.state.exams;
		var items = this.state.posts;
		var acyear = this.state.accyear;

		if (this.state.acyear != '' && this.state.cls != '' && this.state.examname != '') {

			$("#examtimetab").show();
		}
		else {

			$("#examtimetab").hide();
		}

		return (
			<div>
				<AcademicPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<form action="" method="post" role="form" id="examform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<Row>
							<Col md="12">
								<Card>
									<CardHeader>
										<strong>Exam Time Table</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
										Academic Year : &nbsp;&nbsp;
							<select name="acyear" onChange={this.onAcChange} required id="year">
											<option value="">Select Academic Year</option>
											{
												acyear.map(function (item) {
													return <option value={item.id}>{item.value}</option>;
												})
											}
										</select>&nbsp;&nbsp;
										Class : &nbsp;&nbsp;
							<select name="cls" onChange={this.onChange} required id="clas">
											<option value="">Select Class</option>
											{
												items.map(function (item) {
													return <option value={item.id}>{item.class}</option>;
												})
											}
										</select>&nbsp;&nbsp;
										Exam Name : &nbsp;&nbsp;
							<select name="examname" onChange={this.onExChange} required id="exam">
											<option value="">Select Exam</option>
											{
												exa.map(function (item) {
													return <option value={item.id}>{item.exam}</option>;
												})
											}
										</select>
									</CardHeader>
									<CardBody>
										<Row id="examtimetab">
											<Col md="12">
												<Table responsive bordered>
													<thead>
														<tr>
															<th>Subject</th>
															<th>Exam Date</th>
															<th>Time</th>
															<th>Max Mark</th>
															<th>Pass Mark</th>
														</tr>
													</thead>
													<tbody>
														{this.state.subj.map((item, index) =>
															<tr key={item}>
																<td>{item.sub}</td>
																{this.getexamdate(item.subject)}
																{this.getexamtime(item.subject)}
																{this.getmaxmark(item.subject)}
																{this.getpassmark(item.subject)}
															</tr>
														)}
													</tbody>
												</Table>
												<Modal isOpen={this.state.modal1} toggle={this.toggle1} className={this.props.className}>
													<ModalHeader toggle={this.toggle1}>Select</ModalHeader>
													<ModalBody>
														<Row>
															<Col md="12">
																<FormGroup>
																	<Label htmlFor="name">Exam Date <span className="text-danger">*</span></Label>
																	<input type="date" name="exdate" className="form-control" value={this.state.exdate} onChange={this.onChange} />
																</FormGroup>
															</Col>
														</Row>
													</ModalBody>
													<ModalFooter>
														<Button type="submit" color="primary" onClick={this.onUpdate1}>Submit</Button>
														<Button color="secondary" onClick={this.toggle1}>Cancel</Button>
													</ModalFooter>
												</Modal>
												<Modal isOpen={this.state.modal2} toggle={this.toggle2} className={this.props.className}>
													<ModalHeader toggle={this.toggle2}>Select</ModalHeader>
													<ModalBody>
														<Row>
															<Col md="12">
																<FormGroup>
																	<Label htmlFor="name">From <span className="text-danger">*</span></Label>
																	<input type="time" name="stime" className="form-control" value={this.checktime(this.state.stime)} onChange={this.onChange} />
																</FormGroup>
															</Col>
															<Col md="12">
																<FormGroup>
																	<Label htmlFor="name">To <span className="text-danger">*</span></Label>
																	<input type="time" name="etime" className="form-control" value={this.checktime(this.state.etime)} onChange={this.onChange} />
																</FormGroup>
															</Col>
														</Row>
													</ModalBody>
													<ModalFooter>
														<Button type="submit" color="primary" onClick={this.onUpdate2}>Submit</Button>
														<Button color="secondary" onClick={this.toggle2}>Cancel</Button>
													</ModalFooter>
												</Modal>
												<Modal isOpen={this.state.modal3} toggle={this.toggle3} className={this.props.className}>
													<ModalHeader toggle={this.toggle3}>Select</ModalHeader>
													<ModalBody>
														<Row>
															<Col md="12">
																<FormGroup>
																	<Label htmlFor="name">Max Mark <span className="text-danger">*</span></Label>
																	<input type="text" name="maxmark" className="form-control" value={this.state.maxmark} onChange={this.onChange} />
																</FormGroup>
															</Col>
														</Row>
													</ModalBody>
													<ModalFooter>
														<Button type="submit" color="primary" onClick={this.onUpdate3}>Submit</Button>
														<Button color="secondary" onClick={this.toggle3}>Cancel</Button>
													</ModalFooter>
												</Modal>
												<Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
													<ModalHeader toggle={this.toggle}>Select</ModalHeader>
													<ModalBody>
														<Row>
															<Col md="12">
																<FormGroup>
																	<Label htmlFor="name">Pass Mark <span className="text-danger">*</span></Label>
																	<input type="text" name="passmark" className="form-control" value={this.state.passmark} onChange={this.onChange} />
																</FormGroup>
															</Col>
														</Row>
													</ModalBody>
													<ModalFooter>
														<Button type="submit" color="primary" onClick={this.onUpdate}>Submit</Button>
														<Button color="secondary" onClick={this.toggle}>Cancel</Button>
													</ModalFooter>
												</Modal>
											</Col>
										</Row>
									</CardBody>
									<CardFooter>
										<Button type="submit" size="sm" className="btn-right" color="primary"><i className="fa fa-dot-circle-o"></i> Save</Button>
									</CardFooter>
								</Card>
							</Col>
						</Row>
					</form>
				</div>
			</div>
		)
	}
}

export default Exam;


// WEBPACK FOOTER //
// ./src/exams/Exam/Exam.js